<template>
  <horizontal-stepper
    :app-name="appName"
    :steps="steps"
    :active-step="activeStep"
    :before-completed="beforeCompleted"
    :data="data"
    :translations="JSON.parse(translations)"
    :breadcrumbs="JSON.parse(breadcrumbs)"
    :lang="lang"
    :isAndroid="parseInt(isAndroid)"
    :isDesktop="parseInt(isDesktop)"
  ></horizontal-stepper>
</template>

<script>
import { mapActions } from 'vuex'
const HorizontalStepper = () => import('./HorizontalStepper.vue')
const Homepage = () => import('./Steps/Homepage.vue')
const DriverDetails = () => import('./Steps/DriverDetails.vue')
const VehicleDetails = () => import('./Steps/VehicleDetails.vue')
const DriverDocuments = () => import('./Steps/DriverDocuments.vue')
const VehicleDocuments = () => import('./Steps/VehicleDocuments.vue')
const BankAccount = () => import('./Steps/BankAccount.vue')
const ConfirmationState = () => import('./Steps/ConfirmationState.vue')

export default {
  name: 'app',
  props: [
    'appName',
    'driverAndroidAppUrl',
    'translations',
    'breadcrumbs',
    'lang',
    'isAndroid',
    'isDesktop'
  ],
  components: {
    HorizontalStepper
  },
  data () {
    return {
      activeStep: 0,
      data: {
        driverAndroidAppUrl: this.driverAndroidAppUrl
      },
      steps: [
        {
          component: Homepage,
          screenName: 'Driver onboarding - Homepage'
        },
        {
          component: DriverDetails,
          screenName: 'Driver onboarding - Driver details'
        },
        {
          component: VehicleDetails,
          screenName: 'Driver onboarding - Vehicle details'
        },
        {
          component: DriverDocuments,
          screenName: 'Driver onboarding - Driver documents'
        },
        {
          component: VehicleDocuments,
          screenName: 'Driver onboarding - Vehicle documents'
        },
        {
          component: BankAccount,
          screenName: 'Driver onboarding - Bank account'
        },
        {
          component: ConfirmationState,
          screenName: 'Driver onboarding - Confirmation state'
        }
      ]
    }
  },
  methods: {
    ...mapActions([
      'finishOnboarding'
    ]),
    beforeCompleted: function (callback) {
      this.finishOnboarding({
        onsuccess: () => {
          callback()
        },
        onerror: () => {
          this.$toasted.show('Ne pare rău, dar a apărut o eroare.', {
            type: 'error',
            theme: 'bubble',
            duration: 3000
          })
        }
      })
    }
  }
}
</script>
